interface IProps {
    captionData: string
}

export const CaptionComponent = ({captionData}: IProps) => {
    return (
        <figcaption className="mt-2 text-base text-center text-black">
              {captionData}
        </figcaption>
    );
}

export default CaptionComponent;